import { gql, TypedDocumentNode } from "@apollo/client";

import { MutationSpaceDeleteArgs, Space } from "types/generated";

export const SPACE_CREATE = gql`
  mutation SpaceCreate($input: SpaceInput!) {
    spaceCreate(input: $input) {
      id
      name
      description
      parentSpace
      inheritEntities
      accessLevel
      labels
    }
  }
`;

export const SPACE_UPDATE = gql`
  mutation SpaceUpdate($spaceId: ID!, $input: SpaceInput!) {
    spaceUpdate(space: $spaceId, input: $input) {
      id
      name
      description
      parentSpace
      inheritEntities
      accessLevel
      labels
    }
  }
`;

type SpaceDeleteData = {
  spaceDelete: Pick<Space, "id">;
};

type SpaceDeleteVariables = {
  spaceId: MutationSpaceDeleteArgs["space"];
};

export const SPACE_DELETE: TypedDocumentNode<SpaceDeleteData, SpaceDeleteVariables> = gql`
  mutation SpaceDelete($spaceId: ID!) {
    spaceDelete(space: $spaceId) {
      id
    }
  }
`;
